<template>
    <div class="main">
        <FunnelStepsPanel :funnel="getFunnelStore" :steps="getStepDataStore" :loading="loadingSteps" />

        <div :class="['main_inner_wrpr noscroll', {'delete_popup_wrpr': getProductDeletePopup}, {'delete_popup_wrpr': getAutomationPopup.show}]">
            <div class="main-center funnel_steps_page layout-column noscroll">
                <router-view v-if="!loadingSteps" :funnel="getFunnelStore" :steps="getStepDataStore" />
            </div>
        </div>
    </div>
</template>

<script>
import MainSearch from "@/components/MainSearch.vue";

import { mapGetters } from "vuex"
import API from "@/api"
import FunnelStepsPanel from "@/views/funnels/funnel/funnel-steps-panel";

export default {
    name: "FunnelRoot",
		title:"Funnel | Funnelish™",
    components: {
	    FunnelStepsPanel,
      MainSearch
    },
    mixins: [API],
    data: function() {
        return {
        	loadingSteps: false,
            funnel: {},
            stepData: [],
        };
    },
    computed: {
        ...mapGetters([
            "getStepDataStore",
            "getFunnelStore",
            "getProductDeletePopup",
            "getAutomationPopup",
            "getSingleStepStore"
        ])
    },
    methods: {
        updateSidebarData(data, action) {
            if(data && action === 'add') {
                this.stepData.push(data);
                this.$store.dispatch('setSingleStepStore', data);
            } else if(data && action === 'remove') {
                var target = this.stepData.findIndex(step => parseInt(step.id) === parseInt(data));
                this.stepData.splice(target, 1);
            } else if(data && action === 'edit') {
                var target = this.stepData.findIndex(step => parseInt(step.id) === parseInt(data.id));
                this.stepData.splice(target, 1, data);
                this.$store.dispatch('setSingleStepStore', data);
            }
            this.$store.dispatch('setStepDataStore', this.stepData);
        },
        async init(id) {
        	try {
        		this.loadingSteps = true;
		        //Funnel Details
		        var res = await this.api.funnels.get(id);
		        //FunnelSteps
		        if (res.funnel_type) { //Funnel Plus
			        var stepsRes = await this.api.wsteps.getAll(id);
			        this.$store.dispatch('setFunnelStore', res);
			        this.$store.dispatch('setStepDataStore', stepsRes);
		        } else { //ClickFunnels
			        var stepsRes = await this.api.steps.getAll(id);
			        this.$store.dispatch('setFunnelStore', res);
			        this.$store.dispatch('setStepDataStore', stepsRes);
		        }
		        document.title = res.name + ' | Funnelish™';
	        } catch (e) {
        		this.$error(e)
	        } finally {
		        this.loadingSteps = false;
	        }
        },
    },
    created() {
        var {id} = this.$route.params;
        this.init(id);
    }
}
</script>
